import { useState } from "react";
import { Button } from "../../../common/button";
import { PlusIcon } from "@heroicons/react/16/solid";
import Joi, { create } from "joi-browser";
import { Dialog, DialogBody, DialogTitle } from "V2.0/common/dialog";
import { DialogTitleWithClose } from "V2.0/HomePages/HomeModule/CustomAPIs/components/Dialog/DialogTitleWithClose";
import Form from "V2.0/components/Form";
import { createContact } from "..";
import { message } from "antd";
import { fieldTemplate, fieldSchema } from "../models/template";
import { showErrorToast } from "V2.0/utils/showErrorToast";

export function CreateContact(props) {
  const { fetchContacts, projectId } = props;

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const onClose = () => {
    setOpen(false);
    setLoading(false);
  };
  const onOpen = () => setOpen(true);

  const onSubmit = async (data) => {
    const payload = {
      contact: data,
    };

    try {
      const response = await createContact({ projectId, payload });

      if (response.status === 200) {
        message.success("Contact added");
        fetchContacts(projectId);
        onClose();
      }
    } catch (error) {
      showErrorToast(error, "Failed to Create Contact");
    }
  };

  return (
    <>
      <Button onClick={onOpen}>
        <PlusIcon /> Add Contact
      </Button>
      {open && (
        <Dialog open={open} onClose={() => {}}>
          <DialogTitle>
            <DialogTitleWithClose title="Add Contact" onClose={onClose} />
          </DialogTitle>
          <DialogBody>
            <Form
              template={fieldTemplate}
              schema={fieldSchema}
              onSubmit={onSubmit}
              handleSecondary={onClose}
              buttonInfo={{
                buttons: "2",
                primaryLabel: "Add",
                secondaryLabel: "Cancel",
              }}
              loading={loading}
              setLoading={setLoading}
              inputField={{}}
            />
          </DialogBody>
        </Dialog>
      )}
    </>
  );
}
